module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block height"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "detail list"
  }, [_c('li', [_c('p', [_vm._v("Polisnummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.polisnummer))])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Ingangsdatum")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ingangsdatum))])]), _vm._v(" "), (_vm.laatstewijzigingbehandelaar) ? _c('li', [_c('p', [_vm._v("Laatste wijzigingsdatum")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.laatstewijzigingbehandelaar))])]) : _vm._e(), _vm._v(" "), (_vm.kortlopend == 'J') ? _c('li', [_c('p', [_vm._v("Einddatum")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.einddatum))])]) : _c('li', [_c('p', [_vm._v("Verlengingsdatum")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.einddatum))])]), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.looptijd))])]), _vm._v(" "), (_vm.produkttypenaam == 'auto' || _vm.produkttypenaam == 'motor' || _vm.produkttypenaam == 'bromfiets' || _vm.produkttypenaam == 'camper') ? _c('li', [_c('p', [_vm._v("Schadevrije jaren")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zuiverschadevrijejaren) + " jaar")])]) : _vm._e()])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("Verzekering")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Looptijd \n\t\t\t\t\t\t"), _c('a', {
    staticClass: "modal-button",
    attrs: {
      "role": "button",
      "data-toggle": "modal",
      "data-target": "#looptijd-modal"
    }
  }, [_vm._v("j")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "looptijd-modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Looptijd")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n\t\t        Uw contract wordt jaarlijks automatisch verlengd.\n\t\t      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e5ee0b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/polisdetails/verzekering.vue
// module id = 50
// module chunks = 0